import Route from "../Route";
import { Switch } from "react-router-dom";

import ClienteListagem from "../../pages/prouser/clientes/ClienteListagem";
import ClienteCadastro from "../../pages/prouser/clientes/ClienteCadastro";

import TransportadoraListagem from "../../pages/prouser/transportadoras/TransportadoraListagem";
import TransportadoraCadastro from "../../pages/prouser/transportadoras/TransportadoraCadastro";

import FornecedorCadastro from "../../pages/prouser/fornecedores/FornecedorCadastro";
import FornecedorListagemCadastro from "../../pages/prouser/fornecedores/FornecedorListagem";

import PrescricaoListagem from "../../pages/prouser/prescricao/PrescricaoListagem";

import { TransportadoraContextProvider } from "../../pages/prouser/transportadoras/contexts/TransportadoraContext";
import { FornecedorContextProvider } from "../../pages/prouser/fornecedores/contexts/FornecedorContext";
import { PrescricaoContextProvider } from "../../pages/prouser/prescricao/contexts/PrescricaoContext";

export default function Prouser() {
  return (
    <>
      <Switch>
        <Route path="/prouser/cliente/listagem" component={ClienteListagem} />
        <Route path="/prouser/cliente/cadastro" component={ClienteCadastro} />
      </Switch>

      <TransportadoraContextProvider>
        <Switch>
          <Route
            path="/prouser/transportadora/listagem"
            component={TransportadoraListagem}
          />
          <Route
            path="/prouser/transportadora/cadastro"
            component={TransportadoraCadastro}
          />
        </Switch>
      </TransportadoraContextProvider>

      <FornecedorContextProvider>
        <Switch>
          <Route
            path="/prouser/fornecedor/cadastro"
            component={FornecedorCadastro}
          />
          <Route
            path="/prouser/fornecedor/listagem"
            component={FornecedorListagemCadastro}
          />
        </Switch>
      </FornecedorContextProvider>

      <PrescricaoContextProvider>
        <Switch>
          <Route
            path="/prouser/prescricao/listagem"
            component={PrescricaoListagem}
          />
        </Switch>
      </PrescricaoContextProvider>
    </>
  );
}
